import React, { useState } from "react";
import IconeCanal from "../IconeCanal";
import { rotuloCanal } from "../../helpers/canalConexao";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Drawer from "@material-ui/core/Drawer";
import Link from "@material-ui/core/Link";
import InputLabel from "@material-ui/core/InputLabel";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";

import { i18n } from "../../translate/i18n";

import ContactModal from "../ContactModal";
import ContactDrawerSkeleton from "../ContactDrawerSkeleton";
import MarkdownWrapper from "../MarkdownWrapper";
import { parseISO, format } from "date-fns";

const drawerWidth = 320;

const useStyles = makeStyles(theme => ({
	drawer: {
		width: drawerWidth,

		flexShrink: 0,
	},
	drawerPaper: {
		width: drawerWidth,
		display: "flex",
		borderTop: "1px solid rgba(0, 0, 0, 0.12)",
		borderRight: "1px solid rgba(0, 0, 0, 0.12)",
		borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
		borderTopRightRadius: 4,
		borderBottomRightRadius: 4,
	},
	header: {
		display: "flex",
		borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
		backgroundColor: theme.palette.background.default,
		alignItems: "center",
		padding: theme.spacing(0, 1),
		minHeight: "73px",
		justifyContent: "flex-start",
	},
	content: {
		display: "flex",
		backgroundColor: theme.palette.background.paper,
		flexDirection: "column",
		padding: "8px 0px 8px 8px",
		height: "100%",
		overflowY: "scroll",
		...theme.scrollbarStyles,
	},

	contactAvatar: {
		margin: 15,
		width: 160,
		height: 160,
	},

	contactHeader: {
		display: "flex",
		padding: 8,
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		"& > *": {
			margin: 4,
		},
	},

	contactDetails: {
		marginTop: 8,
		padding: 8,
		display: "flex",
		flexDirection: "column",
	},
	contactExtraInfo: {
		marginTop: 4,
		padding: 6,
	},
}));

const ContactDrawer = ({ open, handleDrawerClose, contact, ticket, loading, children }) => {
	const classes = useStyles();

	const [modalOpen, setModalOpen] = useState(false);

	return (
		<Drawer
			className={classes.drawer}
			variant="persistent"
			anchor="right"
			open={open}
			PaperProps={{ style: { position: "absolute" } }}
			BackdropProps={{ style: { position: "absolute" } }}
			ModalProps={{
				container: document.getElementById("drawer-container"),
				style: { position: "absolute" },
			}}
			classes={{
				paper: classes.drawerPaper,
			}}
		>
			{children}
			{!children && <div className={classes.header}>
				<IconButton onClick={handleDrawerClose}>
					<CloseIcon />
				</IconButton>
				<Typography style={{ justifySelf: "center" }}>
					{i18n.t("contactDrawer.header")}
				</Typography>
			</div>}
			{!children && (loading ? (
				<ContactDrawerSkeleton classes={classes} />
			) : (
				<div className={classes.content}>
					<Paper square variant="outlined" className={classes.contactHeader}>
						<Avatar
							alt={contact.name}
							src={contact.profilePicUrl}
							className={classes.contactAvatar}
						></Avatar>

						<Typography>{contact.name}</Typography>
						{!ticket.isGroup && ticket.lead_icode && (
							<Typography>ID do Lead: {ticket.lead_icode}</Typography>
						)}
						<Typography>
							{contact.canal ? (
								<span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
									<IconeCanal tipo={contact.canal} size={13} />
									{rotuloCanal(contact.canal)}
								</span>
							) : (
								<Link href={`tel:${contact.number}`}>{contact.number}</Link>
							)}
						</Typography>
						{contact.isLid && <Typography style={{ color: 'red', fontWeight: "bold" }}>CONTATO COM BLOQUEIO DE PRIVACIDADE</Typography>}
					</Paper>
					<Paper square variant="outlined" className={classes.contactDetails}>
						<ContactModal
							open={modalOpen}
							onClose={() => setModalOpen(false)}
							contactId={contact.id}
						></ContactModal>
						<Typography variant="subtitle1">
							Outras informações
						</Typography>
						{/* O.S e agendamento são campos do lead no ERP: grupo não tem lead,
							então os dois campos não aparecem para ticket de grupo. */}
						{!ticket.isGroup && process.env.REACT_APP_REMOVER_AGENDAMENTO != 'on' && (
							<Paper
								square
								variant="outlined"
								className={classes.contactExtraInfo}
							>
								<InputLabel>Código da O.S</InputLabel>
								<Typography component="div" noWrap style={{ paddingTop: 2 }}>
									{ticket.id_os}
								</Typography>
							</Paper>
						)}
						{!ticket.isGroup && process.env.REACT_APP_REMOVER_AGENDAMENTO != 'on' && (
							<Paper
								square
								variant="outlined"
								className={classes.contactExtraInfo}
							>
								<InputLabel>Data de agendamento</InputLabel>
								<Typography component="div" noWrap style={{ paddingTop: 2 }}>
									{ticket?.agendamento && format(parseISO(ticket.agendamento), "dd/MM/yyyy HH:mm")}
								</Typography>
							</Paper>
						)}
						<Paper
							square
							variant="outlined"
							className={classes.contactExtraInfo}
						>
							<InputLabel>Observações</InputLabel>
							<Typography component="div" noWrap style={{ paddingTop: 2 }}>
								{ticket.observacao}
							</Typography>

						</Paper>

					</Paper>
				</div>
			))}
		</Drawer>
	);
};

export default ContactDrawer;
